import { useEffect, useState } from "react";
import { Autocomplete, SidebarRight } from "@tw/tw-common-js";
import api from "../services/api";
import { Table } from "@tw/tw-common-js";
import UserEdit from "../components/other/UserEdit";
import { useAuth } from "../context/useAuth";

export default function UserList() {
  const [list, setList] = useState([]);
  const [filter, setFilter] = useState({
    isArchived: false,
  });
  const [showSidebar, setShowSidebar] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState();
  const [editItem, setEditItem] = useState();
  const { user } = useAuth();

  useEffect(() => {
    const fetchData = async () => {
      let data = await api.getUsers();
      setList(data.data);
    };

    fetchData();
  }, [user]);

  const config = {
    onClickRow: (item) => {
      setEditItem(item);
      setShowModalEdit(true);
    },
    columns: [
      {
        key: "email",
        header: "Email",
        template: (item) => <span className="main-row">{item.email || "NO EMAIL"}</span>,
      },
      {
        key: "firstName",
        header: "First Name",
        template: (item) => <span>{item.firstName || "-"}</span>,
      },
      {
        key: "lastName",
        header: "Last Name",
        template: (item) => <span>{item.lastName || "-"}</span>,
      },
      {
        key: "_employee",
        header: "HR Code",
        template: (item) => <span>{item._employee || "-"}</span>,
      },
      {
        header: "Role",
        key: "_role",
        template: (item) => (
          <span>
            {item.roles && item.roles.length > 0
              ? item.roles.map((role) => (
                  <div key={role.name} className="badge small">
                    {role.name}
                  </div>
                ))
              : "No Role"}
          </span>
        ),
      },
    ],
  };

  const setFilterValue = (key, value) => {
    setFilter((prev) => {
      let set = {};
      set[key] = value;
      return { ...prev, ...set };
    });
  };

  const filteredList = list.filter((item) => {
    if (filter.isArchived !== "" && filter.isArchived !== undefined) {
      if (!!item.isArchived !== filter.isArchived) return false;
    }
    if (filter.email && !item.email?.toLowerCase().includes(filter.email.toLowerCase())) return false;
    return true;
  });

  return (
    <>
      <div className={"page-wrapper" + (showSidebar ? " show-sidebar-right" : "")}>
        <div className="btn-bar">
          <div className="btn-bar-left">
            <div className="title">Users</div>
          </div>
          <div className="btn-bar-right">
            <div className="searchbar-container">
              <input
                type="text"
                className="searchbar-input"
                placeholder="Search"
                value={filter.email || ""}
                onChange={(e) => setFilterValue("email", e.target.value)}
              />
              {filter.email && (
                <span className="searchbar-clear" onClick={() => setFilterValue("email", "")} title="Clear">
                  ×
                </span>
              )}
              <span className="searchbar-icon">
                <i className="material-icons">search</i>
              </span>
            </div>

            {!showSidebar && (
              <button className="blue-light" onClick={() => setShowSidebar(true)}>
                <span className="material-symbols-outlined">filter_alt</span>
                <div>Filters</div>
              </button>
            )}
          </div>
        </div>

        <div className="table-container">
          <Table
            config={config}
            filter={filter}
            data={filteredList}
            rowIcon="account_circle"
            rowClassName={(row) => (row.isArchived ? "archived-row" : "")}
          ></Table>
        </div>
      </div>

      <SidebarRight show={showSidebar}>
        <div className="sidebar-header">
          <div className="sidebar-title">Filters</div>
          <div className="sidebar-title-right">
            <button className="medium icon-right" onClick={() => setShowSidebar(false)}>
              Close
              <i className="material-icons">chevron_right</i>
            </button>
          </div>
        </div>
        <div className="filter-container">
          <div className="filter-row">
            <input
              type="text"
              value={filter.email || ""}
              placeholder="E-mail"
              onChange={(e) => setFilterValue("email", e.target.value)}
            />
            <button className="small btn-reset" onClick={() => setFilterValue("email", "")}>
              <i className="material-icons">close</i>
            </button>
          </div>
          <div className="filter-row">
            <Autocomplete
              allowClear={false}
              items={[
                { value: false, name: "Active" },
                { value: true, name: "Archived" },
              ]}
              value={filter.isArchived}
              onSelect={(item) => setFilterValue("isArchived", item.value)}
              placeholder="Active users"
            />
            <button className="small btn-reset" onClick={() => setFilterValue("isArchived", "")}>
              <i className="material-icons">close</i>
            </button>
          </div>
        </div>
        <div className="sidebar-footer">
          <button onClick={() => setFilter({ email: "", firstName: "", lastName: "", teamName: "" })}>
            <i className="material-icons">close</i>
            Reset
          </button>
        </div>
      </SidebarRight>

      {showModalEdit && <UserEdit userInit={editItem} list={list} setList={setList} close={() => setShowModalEdit(false)} />}
    </>
  );
}
